import {
  FETCH_STATELIST_SUCCESS_ACTION,
  FETCH_STATE_SEARCH_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_STATELIST_SUCCESS_ACTION:
      return {
        ...state,
        stateList: action.payload.rows,
        stateDtlsCount: action.payload.count,
      };
    case FETCH_STATE_SEARCH_SUCCESS_ACTION:
    
      return {
        ...state,
        stateSearchList: action.payload.rows,
        statesSearchCount:action.payload.count
      };
   

    default:
      return {
        ...state,
      };
  }
}
